/**
 * Step 8 — AI demo
 *
 * Spec: specs/onboarding-rebuild.md → Act 2 step 8
 *
 * Live Claude chat with Grace. User picks a curated chip or types their own
 * first message → real /chat function streams the response. Hard 10s
 * timeout falls back to a canned response if the API errors.
 *
 * Variant scaffolding retired 2026-05-14 — synthesis is production.
 */

import AiDemoSynthesis from './AiDemo.synthesis'

export default function AiDemoStep({ profile, onContinue, onConversationCreated }) {
  return (
    <AiDemoSynthesis
      profile={profile}
      onContinue={onContinue}
      onConversationCreated={onConversationCreated}
    />
  )
}
